var exports = {
  "k": "x24da60e8--207132--container",
};

module.exports = exports;
